"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseLimitationType = void 0;
var LicenseLimitationType;
(function (LicenseLimitationType) {
    LicenseLimitationType["GD_DESKTOP_BACKGROUND"] = "GD_DESKTOP_BACKGROUND";
    LicenseLimitationType["GD_AUDIO"] = "GD_AUDIO";
    LicenseLimitationType["GD_CHOOSE_IMAGE"] = "GD_CHOOSE_IMAGE";
    LicenseLimitationType["GD_START_TEXT"] = "GD_START_TEXT";
    LicenseLimitationType["GD_HIGH_SCORE_TEXT"] = "GD_HIGH_SCORE_TEXT";
    LicenseLimitationType["GD_RANKING_TEXT"] = "GD_RANKING_TEXT";
    LicenseLimitationType["GS_SPLIT_GAME"] = "GS_SPLIT_GAME";
    LicenseLimitationType["GS_CHANGE_FONT"] = "GS_CHANGE_FONT";
    LicenseLimitationType["GS_LEADERBOARD"] = "GS_LEADERBOARD";
    LicenseLimitationType["GS_EXTERNAL_LEADERBOARD"] = "GS_EXTERNAL_LEADERBOARD";
    LicenseLimitationType["GS_PRIZES"] = "GS_PRIZES";
    LicenseLimitationType["GS_CHALLENGE"] = "GS_CHALLENGE";
    LicenseLimitationType["GS_WELCOME_EMAIL"] = "GS_WELCOME_EMAIL";
    LicenseLimitationType["GS_TUTORIAL"] = "GS_TUTORIAL";
    LicenseLimitationType["GS_LUCK_BASED_WINS_ENABLED"] = "GS_LUCK_BASED_WINS_ENABLED";
    LicenseLimitationType["GA_DATA_EXPORT"] = "GA_DATA_EXPORT";
    LicenseLimitationType["GA_GENERATE_WINNERS"] = "GA_GENERATE_WINNERS";
    LicenseLimitationType["ANALYTICS_ENABLED"] = "ANALYTICS_ENABLED";
    LicenseLimitationType["ASSETS_FONT_ENABLED"] = "ASSETS_FONT_ENABLED";
    LicenseLimitationType["GC_ENABLED"] = "GC_ENABLED";
    LicenseLimitationType["BRAND_USER_BASE_ENABLED"] = "BRAND_USER_BASE_ENABLED";
    LicenseLimitationType["BRAND_USER_BASE_EXPORT"] = "BRAND_USER_BASE_EXPORT";
    LicenseLimitationType["BRAND_USER_BASE_SEND_EMAIL"] = "BRAND_USER_BASE_SEND_EMAIL";
    LicenseLimitationType["GAMIFICATION_ENABLED"] = "GAMIFICATION_ENABLED";
    LicenseLimitationType["DATA_INTEGRATION_ENABLED"] = "DATA_INTEGRATION_ENABLED";
})(LicenseLimitationType || (exports.LicenseLimitationType = LicenseLimitationType = {}));
